import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import AnimatedText from "../components/AnimatedText";
import Seo from "../components/Seo";
import IM from "../assets/images/Property&RealState/IM.png";
import PT from "../assets/images/Property&RealState/PT.png";
import RED from "../assets/images/Property&RealState/RED.png";

const PropertyAndRealEstateLaw = () => {
  const [showTop, setShowTop] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    const onScroll = () => {
      setShowTop(window.pageYOffset > 400);
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      const p = max > 0 ? doc.scrollTop / max : 0;
      setScrollProgress(p);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="info-page-wrapper font-inter">
      <Seo
        title="Property & Real Estate Law | Expert Lawyers - Legal Platform"
        description="Get expert legal advice on property and real estate matters. Our verified lawyers handle conveyancing, disputes, tenancy issues, and property transactions."
        canonicalPath={process.env.REACT_APP_BASE_PATH+"/property-real-estate-law"}
        image="/favicon.png"
      />
      <Header />
      <Breadcrumbs />
      <main className="info-page-section py-5">
        <div
          className="info-page-main-card"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h1 className="home-hero-title text-center"><AnimatedText text="Property & Real Estate Law" /></h1>
          <div className="home-hero-text text-center">
            <AnimatedText text="Navigate the complexities of property and real estate law with expert legal guidance. Our verified lawyers provide support for property transactions, rental disputes, title transfers, and real estate investments, ensuring your assets are protected and your transactions are legally compliant." />
          </div>
        </div>

        <div className="info-page-list">
          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="150"
          >
            <div className="info-page-block-content">
              <h3 className="info-page-block-title"><AnimatedText text="Property Transactions" /></h3>
              <div className="info-page-block-text">
                <AnimatedText text="Secure your property purchases and sales with professional legal review. We handle due diligence, contract review, and title verification to ensure a smooth transfer of ownership for residential and commercial properties." />
              </div>
            </div>
            <div className="info-page-block-image-wrapper">
              <img src={PT} alt="Property Transactions" className="info-page-block-image" />
            </div>
          </div>

          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="info-page-block-content">
              <h3 className="info-page-block-title"><AnimatedText text="Real Estate Disputes" /></h3>
              <div className="info-page-block-text">
                <AnimatedText text="Resolve landlord-tenant conflicts, boundary disputes, and construction issues efficiently. Our legal experts provide mediation and representation to protect your property rights and achieve fair resolutions." />
              </div>
            </div>
            <div className="info-page-block-image-wrapper">
              <img src={RED} alt="Real Estate Disputes" className="info-page-block-image" />
            </div>
          </div>

          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="250"
          >
            <div className="info-page-block-content">
              <h3 className="info-page-block-title"><AnimatedText text="Investment Management" /></h3>
              <div className="info-page-block-text">
                <AnimatedText text="Get specialized advice for real estate investment portfolios. We provide legal structures, tax compliance guidance, and risk management strategies for domestic and international property investments." />
              </div>
            </div>
            <div className="info-page-block-image-wrapper">
              <img src={IM} alt="Investment Management" className="info-page-block-image" />
            </div>
          </div>
        </div>
      </main>
      {showTop && (
        <button
          type="button"
          className="scroll-top-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          style={{ "--progress": `${Math.round(scrollProgress * 100)}%` }}
        >
          <span className="scroll-top-ring" />
          <i className="bi bi-arrow-up-short" />
        </button>
      )}
      <Footer />
    </div>
  );
};

export default PropertyAndRealEstateLaw;
